import { reactive } from 'vue'

export const BookingStore = reactive({
    current_step: 1,
    selected_prestations: [],
    selected_category: null,
    selected_location: null,
    selected_agenda: null,
    rdvToModify: null,

  select_prestations(selected_prestations, selected_location, selected_agenda){
    this.selected_prestations = selected_prestations;
    this.selected_agenda = selected_agenda;
    this.selected_location = selected_location;
  },

  set_step(value){
    this.current_step = value;
  }
})